
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CardBody, Card, CardTitle } from 'reactstrap'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { getActions } from '../../../actions/adminActions'

var moment = require('moment')

class Actions extends Component {
  componentDidMount () {
    // have to give text area contents afterwards
    this.props.getActions(this.props.match.params.appealID)
  }
  render () {
    this.props.admin.actions.sort(function (a, b) {
      return new Date(b.timestamp) - new Date(a.timestamp)
    })

    return (
      <div>
        <Card>
          <CardTitle>Activity</CardTitle>
          <CardBody>
            <div className='actions'>
              {
                this.props.admin.actions.map((action, i) => {
                  // Return the element. Also pass key
                  return (<p key={i}><b>{moment(action.timestamp).format('DD/MM/YY HH:mm')}</b> - {action.activity}</p>)
                })}
            </div>
          </CardBody>
        </Card>
      </div>
    )
  }
}

Actions.propTypes = {
  admin: PropTypes.object,
  match: PropTypes.object,
  getActions: PropTypes.func
}

const mapStateToProps = ({ admin }) => ({
  admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getActions
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Actions))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminAppeal/_Actions.jsx